module.exports = __webpack_public_path__ + "static/media/email.61d2fbd0.svg";